import { useCallback } from 'react'

import { getCoreAsset, getPolicyholder, Proposal, Quote } from '../../../../domain'
import { useAdjustments } from '../../../../state'
import { ChangeConfig, ChangeType } from '../../../../state/configuration'
import { toData } from '../../helpers'

export const useProposalData = (proposal: Proposal) =>
  useQuoteData(proposal.quote, proposal.startAt)

export const useQuoteData = (quote: Quote, startAt?: string) => {
  const { getAdjustment } = useAdjustments()

  return useCallback(
    (change: ChangeConfig) => {
      const { data: profile } = getPolicyholder(quote)
      const { data: asset, voluntaryExcess } = getCoreAsset(quote)
      const { data: version } = quote

      switch (change.changeType) {
        case ChangeType.PROFILE_DISCLOSURE:
          return toData(profile, change.update)
        case ChangeType.ASSET_DISCLOSURE:
          return toData(asset, change.update)
        case ChangeType.QUOTE_DISCLOSURE:
          return toData(version, change.update)
        case ChangeType.START_DATE_CHANGE:
          return startAt
        case ChangeType.REQUEST_COVER_OPTION:
          return quote.requestedOptionalCovers[change.coverCode]
        case ChangeType.VOLUNTARY_EXCESS:
          return voluntaryExcess
        case ChangeType.PROFILES_REPEATER:
          return quote.insuredProfiles.map(({ data }) =>
            change.adjustments.reduce((acc, field) => {
              const adjustment = getAdjustment(field)

              switch (adjustment.changeType) {
                case ChangeType.PROFILE_DISCLOSURE:
                  return {
                    ...acc,
                    [field]: toData(data, adjustment.update),
                  }
                default:
                  return acc
              }
            }, {}),
          )
      }
    },
    [quote, startAt],
  )
}
